
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    pBtnInfo: {} as any,
  },
});
